import { toast } from 'react-toastify'

const useToast = () => {
  const options = {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
  }

  const successToast = (message) => {
    toast.success(message, options)
  }

  const errorToast = (message) => {
    toast.error(message, options)
  }

  const infoToast = (message) => {
    toast.info(message, options)
  }

  const warningToast = (message) => {
    toast.warning(message, options)
  }

  return {
    successToast,
    errorToast,
    infoToast,
    warningToast,
  }
}

export default useToast
